<script setup lang="ts">
import {
	NavigationMenuContent,
	NavigationMenuItem,
	NavigationMenuList,
	NavigationMenuTrigger,
	PopoverContent,
	PopoverPortal,
	PopoverRoot,
	PopoverTrigger,
} from "reka-ui";
import type { ClassProps } from "../../lib/base-props";
import type { PlacementProps } from "../../lib/placement";
import { cn } from "../../lib/utils";

defineOptions({ inheritAttrs: false });

interface Props extends ClassProps, PlacementProps {}
const props = withDefaults(defineProps<Props>(), {
	side: "right",
	align: "start",
});
</script>

<template>
	<NavigationMenuItem as="div">
		<PopoverRoot>
			<PopoverTrigger asChild>
				<NavigationMenuTrigger asChild>
					<slot name="trigger" />
				</NavigationMenuTrigger>
			</PopoverTrigger>

			<PopoverPortal>
				<PopoverContent forceMount side="right" align="start">
					<NavigationMenuContent>
						<NavigationMenuList
							as="ul"
							:class="cn('menu popover gap-1', props.class)"
							v-bind="$attrs"
						>
							<slot />
						</NavigationMenuList>
					</NavigationMenuContent>
				</PopoverContent>
			</PopoverPortal>
		</PopoverRoot>
	</NavigationMenuItem>
</template>
